exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.blueText[data-v-12eb5ba4] {\n  color: #12bcf1;\n}\n#appName[data-v-12eb5ba4] {\n  color: grey;\n  font-weight: bold;\n}\n#searchCountry[data-v-12eb5ba4] {\n  margin-top: 0;\n}\n.icon-password[data-v-12eb5ba4] {\n  width: 28px;\n  height: 28px;\n}\n.page-content[data-v-12eb5ba4] {\n  overflow: hidden;\n}\n.no-gutter[data-v-12eb5ba4], .card[data-v-12eb5ba4] {\n  margin-left: 0px;\n  margin-right: 0px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-12eb5ba4","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/user/CMRegister.vue
// module id = 1103
// module chunks = 2